import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { cn } from '@/utils/merge';

const Autocomplete = ({
	label,
	value,
	onChangeText,
	suggestions,
	getResults,
	error,
	errorText,
	onBlur,
	onFocus,
	size,
	rightComponents,
}) => {
	return (
		<div
			className='location-search-section'
			style={{ position: 'relative', alignSelf: 'stretch', width: '100%', zIndex: 1000000 }}
		>
			<FloatingTextinput
				label={label}
				value={value}
				onChange={onChangeText}
				onBlur={onBlur}
				onFocus={onFocus}
				error={error}
				errorText={errorText}
				white
				size={size}
				rightComponents={rightComponents}
				// shouldLog
			/>

			<div className={`autocomplete-dropdown-container autocomplete-dropdown-overwrite rounded-md`}>
				{suggestions.map((suggestion, idx) => {
					//   const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
					// inline style for demonstration purpose

					const classNameBorder =
						idx === 0 ? 'rounded-t-md ' : idx === suggestions.length - 1 ? ' rounded-b-md ' : '';
					return (
						<div
							key={suggestion.placeId}
							className={cn(
								'cursor-pointer border-1 border-slate-300 bg-white p-0.5 py-1 pl-2',
								classNameBorder,
							)}
							onMouseDown={e => e.preventDefault()} // ← prevents blur before click resolves
							onClick={() => getResults(suggestion.text, suggestion.placeId)}
							// style={{borderTop: }}
						>
							<span>{suggestion.text}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Autocomplete;
